import c from '../skillpics/c.jpeg'
import java from '../skillpics/java.jpeg'
import jenkins from '../skillpics/Jenkins.jpg'
import prom from '../skillpics/Prometheus.jpg'
import k8s from '../skillpics/k8.jpg'
import aws from '../skillpics/AWS.jpg'
import terraform from '../skillpics/Terraform.jpg'
import js from '../skillpics/javascript.jpeg'
import react from '../skillpics/react.jpeg'
import node from '../skillpics/node.jpeg'
import spring from '../skillpics/springboot.jpeg'
import mysql from '../skillpics/mysql.jpeg'
import maven from '../skillpics/maven.jpeg'
import webtrc from '../skillpics/webrtc.jpeg'
import tail from '../skillpics/tailwind.jpeg'
import anaconda from '../skillpics/anaconda.jpeg'
import bash from '../skillpics/bash.jpeg'
import docker from '../skillpics/docker.jpeg'
import eclipse from '../skillpics/eclipse.jpeg'
import figma from '../skillpics/figma.jpeg'
import firebase from '../skillpics/firebase.jpeg'
import git from '../skillpics/git.jpeg'
import github from '../skillpics/github.jpeg'
import intelij from '../skillpics/intelij.jpeg'
import ps from '../skillpics/ps.jpeg'
import unbuntu from '../skillpics/ubuntu.jpeg'
import vscode from '../skillpics/vscode.jpeg'
export const skillsData = {
  Devopstools: [
    //{ name: "C", logo: c },
    
    { name: "Docker", logo: docker },
    { name: "GitHub", logo: github },
    {name: "Jenkins", logo: jenkins},
    {name: "Prometheus", logo: prom},
    {name: "Kubernetes", logo: k8s},
    {name: "Terraform", logo: terraform},
    //{ name: "Python", logo: python},
    //{ name: "HTML5", logo: html },
    //{ name: "CSS3", logo: css },


  ],
  technical: [
    { name: "React", logo: react },
    { name: "Java", logo: java },
    { name: "Node.js", logo: node },
    { name: "Spring Boot", logo: spring },
    { name: "Git", logo: git },
    { name: "Mysql", logo: mysql },
    { name: "Webrtc", logo: webtrc },
    { name: "Maven", logo: maven },

  ],

  platforms: [
    { name: "Ubuntu", logo: unbuntu },
    { name: "Firebase", logo: firebase },
    { name: "AWS", logo: aws }
  ],

  Extra: [
    { name: "Figma", logo: figma },
    { name: "PhotoShop", logo: ps },    
    { name: "Bash", logo: bash }
  ]
};
